import { render, staticRenderFns } from "./BulkCall.vue?vue&type=template&id=aac98a34&"
import script from "./BulkCall.vue?vue&type=script&lang=js&"
export * from "./BulkCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports